import React from 'react';
import PropTypes from 'prop-types';
import { AddressDisplay } from '@vp/address-display';
import { useTranslations } from '@vp/om-translations';
import { Typography } from '@vp/swan';
import useSiteData from '../../../hooks/useSiteData';
import { OrderDetailsCardHeading } from './OrderDetailsCardHeading';

export const PickupPointDisplay = ({ pickupPointAddressData }) => {
  const pickupPointName = pickupPointAddressData.metadata?.pickupPointName;
  const {
    streetName,
    city,
    postalCode,
    state,
    country,
    firstName,
    lastName,
    phone,
  } = pickupPointAddressData;

  const [pickupPointDisplay] = useTranslations(['pickupPointDisplay']);

  // To preserve PuP address display order, we need to keep the 'pickupPersonNameBlock' and 'pickupPersonPhoneBlock',
  // and have AddressDisplay from address-form handle the street name, state and country name etc.
  const pickupPersonNameBlock = `${pickupPointDisplay.pickupBy}: ${firstName} ${lastName}`;
  const pickupPersonPhoneBlock = `${phone}`;

  const { locale } = useSiteData();

  return (
    <>
      <OrderDetailsCardHeading>
        {pickupPointDisplay.title}
      </OrderDetailsCardHeading>
      <Typography>{pickupPointName}</Typography>
      <AddressDisplay
        address={{
          streetName,
          city,
          state,
          postalCode,
          country,
        }}
        locale={locale}
      />
      <Typography>{pickupPersonNameBlock}</Typography>
      <Typography>{pickupPersonPhoneBlock}</Typography>
    </>
  );
};

PickupPointDisplay.propTypes = {
  pickupPointAddressData: PropTypes.object.isRequired,
};
